/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Tableheaders_Starts1Inputs */

const id_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai`)
};

const ms_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mula`)
};

const da_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter`)
};

const de_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginnt`)
};

const en_us2_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starts`)
};

const es_es2_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio`)
};

const es_mx2_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio`)
};

const fil_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magsisimula`)
};

const fr_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Début`)
};

const it_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizio`)
};

const hu_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kezdés`)
};

const nl_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

const no_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter`)
};

const pl_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpoczyna`)
};

const pt_br2_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começa`)
};

const pt_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Início`)
};

const ro_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Începe`)
};

const fi_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alkaa`)
};

const sv_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Börjar`)
};

const vi_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu`)
};

const tr_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlangıç`)
};

const cs_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Začíná`)
};

const bg_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Започва`)
};

const ru_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начало`)
};

const uk_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Початок`)
};

const ar_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البدء`)
};

const hi_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शुरू`)
};

const th_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เริ่ม`)
};

const ja_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始`)
};

const zh_cn2_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始时间`)
};

const zh_hant1_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始時間`)
};

const ko_home_tableheaders_starts1 = /** @type {(inputs: Home_Tableheaders_Starts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시작`)
};

/**
* | output |
* | --- |
* | "Starts" |
*
* @param {Home_Tableheaders_Starts1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_tableheaders_starts1 = /** @type {((inputs?: Home_Tableheaders_Starts1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Tableheaders_Starts1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_tableheaders_starts1(inputs)
	if (locale === "ms") return ms_home_tableheaders_starts1(inputs)
	if (locale === "da") return da_home_tableheaders_starts1(inputs)
	if (locale === "de") return de_home_tableheaders_starts1(inputs)
	if (locale === "en-US") return en_us2_home_tableheaders_starts1(inputs)
	if (locale === "es-ES") return es_es2_home_tableheaders_starts1(inputs)
	if (locale === "es-MX") return es_mx2_home_tableheaders_starts1(inputs)
	if (locale === "fil") return fil_home_tableheaders_starts1(inputs)
	if (locale === "fr") return fr_home_tableheaders_starts1(inputs)
	if (locale === "it") return it_home_tableheaders_starts1(inputs)
	if (locale === "hu") return hu_home_tableheaders_starts1(inputs)
	if (locale === "nl") return nl_home_tableheaders_starts1(inputs)
	if (locale === "no") return no_home_tableheaders_starts1(inputs)
	if (locale === "pl") return pl_home_tableheaders_starts1(inputs)
	if (locale === "pt-BR") return pt_br2_home_tableheaders_starts1(inputs)
	if (locale === "pt") return pt_home_tableheaders_starts1(inputs)
	if (locale === "ro") return ro_home_tableheaders_starts1(inputs)
	if (locale === "fi") return fi_home_tableheaders_starts1(inputs)
	if (locale === "sv") return sv_home_tableheaders_starts1(inputs)
	if (locale === "vi") return vi_home_tableheaders_starts1(inputs)
	if (locale === "tr") return tr_home_tableheaders_starts1(inputs)
	if (locale === "cs") return cs_home_tableheaders_starts1(inputs)
	if (locale === "bg") return bg_home_tableheaders_starts1(inputs)
	if (locale === "ru") return ru_home_tableheaders_starts1(inputs)
	if (locale === "uk") return uk_home_tableheaders_starts1(inputs)
	if (locale === "ar") return ar_home_tableheaders_starts1(inputs)
	if (locale === "hi") return hi_home_tableheaders_starts1(inputs)
	if (locale === "th") return th_home_tableheaders_starts1(inputs)
	if (locale === "ja") return ja_home_tableheaders_starts1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_tableheaders_starts1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_tableheaders_starts1(inputs)
	return ko_home_tableheaders_starts1(inputs)
});
export { home_tableheaders_starts1 as "home.tableHeaders.starts" }